import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import { Facebook, Twitter, Instagram, Linkedin, Phone, Mail, MapPin, Send } from "lucide-react";
export default function GlobalFooter() {
  const currentYear = new Date().getFullYear();
  const businessName = "Ledotravel";
  const missionStatement = "Ledotravel is a comprehensive car rental company offering flexible car and van rental, vehicle lease, and business corporate solutions. We are your one-stop automotive partner.";
  const address = "room 12 Suite 2, 360 Edge Lane Innovation Pak, Baylis, Liverpool L7 9NJ";
  const phone = "07563050045";
  const email = "Fleetmanagement@swiftwindltd.co.uk";
  const services = [{
    name: "Car and Van Rental",
    href: "/RentalFleetPage"
  }, {
    name: "Vehicle Leasing",
    href: "/LeaseBusinessPage"
  }, {
    name: "Business Corporate Solutions",
    href: "/LeaseBusinessPage"
  }, {
    name: "Second-Hand Car Sales",
    href: "/PreOwnedExcellencePage"
  }];
  const socialLinks = [{
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }];
  return <section id="global-footer" className="dark bg-background text-foreground relative">
      <Separator className="bg-border/10" />
      
      <div className="container mx-auto px-4 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          
          {}
          <div className="space-y-6">
            <Link to="/" className="block w-fit">
              <img src="/img/ledotravel_logo_white.png" alt={`${businessName} Logo`} className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
              {missionStatement}
            </p>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold tracking-tight text-foreground">Services</h3>
            <ul className="space-y-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to={service.href} className="text-muted-foreground hover:text-primary transition-colors text-sm flex items-center gap-2 group">
                    <span className="w-1.5 h-1.5 rounded-lg bg-primary/0 group-hover:bg-primary transition-all duration-300" />
                    {service.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold tracking-tight text-foreground">Contact Us</h3>
            <ul className="space-y-4">
              <li data-index={0}>
                <Link to={`tel:${phone.replace(/\D/g, '')}`} className="flex items-start gap-3 text-muted-foreground hover:text-primary transition-colors group">
                  <Phone className="w-5 h-5 mt-0.5 shrink-0 text-primary group-hover:text-primary/80 transition-colors" />
                  <span className="text-sm">{phone}</span>
                </Link>
              </li>
              <li data-index={1}>
                <Link to={`mailto:${email}`} className="flex items-start gap-3 text-muted-foreground hover:text-primary transition-colors group">
                  <Mail className="w-5 h-5 mt-0.5 shrink-0 text-primary group-hover:text-primary/80 transition-colors" />
                  <span className="text-sm">{email}</span>
                </Link>
              </li>
              <li data-index={2}>
                <div className="flex items-start gap-3 text-muted-foreground">
                  <MapPin className="w-5 h-5 mt-0.5 shrink-0 text-primary" />
                  <span className="text-sm">{address}</span>
                </div>
              </li>
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold tracking-tight text-foreground">Stay Updated</h3>
            <p className="text-muted-foreground text-sm">
              Subscribe to our newsletter for the latest fleet updates and exclusive offers.
            </p>
            {}
            <div className="space-y-3">
              <div className="relative">
                <Input type="email" placeholder="Enter your email" className="bg-muted/50 border-border/50 focus-visible:ring-primary/50 pr-12" />
                <Button size="icon" className="absolute right-0 top-0 h-full rounded-l-none aspect-square">
                  <Send className="w-4 h-4" />
                  <span className="sr-only">Subscribe</span>
                </Button>
              </div>
            </div>
            
            <div className="pt-2">
              <div className="flex gap-4">
                {socialLinks.map((social, i) => {
                const Icon = social.icon;
                return <Link key={i} data-index={i} to={social.href} newTab className="text-muted-foreground hover:text-primary transition-colors p-2 hover:bg-muted/50 rounded-lg -ml-2 first:ml-0" aria-label={social.label}>
                      <Icon className="w-5 h-5" />
                    </Link>;
              })}
              </div>
            </div>
          </div>

        </div>

        <Separator className="my-8 bg-border/10" />

        <div className="text-muted-foreground text-sm text-center my-4">
          <p>Ledo Travel is a trading name of Swiftwind Limited.</p>
          <p>Swiftwind Limited is registered in England and Wales.</p>
          <p>Company Number: 15926859</p>
          <p>Registered Office:</p>
          <p>Suite 2, 360 Edge Lane, Regus, Fairfield Liverpool Innovation Park, Baylis, Liverpool, L7 9NJ</p>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground">
          <p>&copy; {currentYear} {businessName}. All rights reserved.</p>
         <div className="flex gap-6">
  <a href="/Policies" className="hover:text-foreground transition-colors">
    Privacy Policy
  </a>

  <a href="/Policies" className="hover:text-foreground transition-colors">
    Terms of Service
  </a>

  <a href="/Policies" className="hover:text-foreground transition-colors">
    Cookie Policy
  </a>
</div>
        </div>
      </div>
    </section>;
}